import { Link } from 'react-router'
import { Plus } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EmptyStateAction {
  label: string
  to?: string
  onClick?: () => void
}

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
  action?: EmptyStateAction
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border py-16">
      <div className="bg-primary/10 mb-4 flex size-14 items-center justify-center rounded-full">
        <Icon className="text-primary size-7" />
      </div>
      <h3 className="text-lg font-medium">{title}</h3>
      {description && <p className="text-muted-foreground mt-1 text-sm">{description}</p>}
      {action && (
        <div className="mt-4">
          {action.to ? (
            <Button asChild>
              <Link to={action.to}>
                <Plus className="mr-2 size-4" />
                {action.label}
              </Link>
            </Button>
          ) : (
            <Button onClick={action.onClick}>
              <Plus className="mr-2 size-4" />
              {action.label}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
